<!--<div #pivot_wrap id="pivot_wrapper" style="position:static !important;height:96%;">-->
<!--  <div #pivot_anchor></div>-->
<!--</div>-->

<div #pivotWrap id="pivot_wrapper" style="position:static !important;height:96%;">
<app-wbr-pivot #pivotAnchor [toolbar]="true" (beforetoolbarcreated)="customizeToolbar($event)"></app-wbr-pivot>

</div>
